<template>
    <div class="learnover">
        <div class="learnover-wrap">
           <div style="background:#e69b3f;width:498px;height:62px;">

               <img src="../../../static/courseplayer/over.png" alt="">
           </div>
           <div style="height:21px;line-height:21px;width:100%;text-align:center;margin-top:56px;font-size:21px;">
               本节已经学习完啦，去测验一下吧！
           </div>
        </div>
        
    </div>

</template>

<script>

    export default {
        name: "learnover",
        data() {
            return {
                list:[],
            }
        },
        methods: {
            
        },
        created(){
                      
        },
        mounted() {
        
        }
    }
</script>

<style scoped lang="less">
    a{text-decoration: none ;}
    li{list-style: none;}
    .learnover{
        position: fixed;top:0px;width:100%;height:100%;z-index:44;
        background:rgba(0,0,0,0.6);
        .learnover-wrap{
            width:498px;height:231px;background:white;
            position:absolute;top:0px;bottom:0px;left:0px;right:0px;margin:auto;
            img{
                display: block;position: absolute;top:-78px;left:20px;
                width:157px;height:140px;
            }
            
        }
    }


</style>